import { Component } from 'react';
import styled from 'styled-components';
import { SortableHandle } from 'react-sortable-hoc';
import { Span } from '@workramp/ui';
import AssetPickerTypes from '~/components/common/asset-picker/asset-picker-types';
import TimeUtils from '../../../common/time-utils';
import { common, theme } from '../../../styles';
import LearningObjectIcon from '../../common/asset-picker/LearningObjectIcon';

export default class AcademyCertificationContentItem extends Component {
  render() {
    const { certificationContent } = this.props;

    return (
      <Wrapper>
        {this.props.isEditing && this.renderDragHandle()}
        {this.renderTypeIcon()}
        {this.renderTitle()}
        {certificationContent.content.timeEstimateSeconds > 0 && this.getTimeEstimate()}
        {this.props.isEditing && this.renderDeleteIcon()}
      </Wrapper>
    );
  }

  renderDragHandle = () => {
    const DragHandle = SortableHandle(() => (
      <DragHandleIcon className="task-object-drag task-object-icon allow-draggable" src="/images/move_hover_icon.svg" />
    ));

    return <DragHandle />;
  };

  renderDeleteIcon = () => (
    <DeleteIcon
      onClick={() => this.props.onDeleteClick(this.props.certificationContent)}
      src="/images/cross_icon_grey.svg"
    />
  );

  renderTypeIcon = () => {
    const { certificationContent } = this.props;

    return (
      <LearningObjectIconMarginAdder>
        <LearningObjectIcon
          type={certificationContent.contentType}
          style={{
            width: '14px',
          }}
        />
      </LearningObjectIconMarginAdder>
    );
  };

  renderTitle = () => {
    const title = this.props.certificationContent.content.title || this.props.certificationContent.content.name;
    const itemForUrl = {
      type: this.props.certificationContent.contentType,
      id: this.props.certificationContent.contentId,
      academyId: this.props.certificationContent.content?.academyId,
    };
    const href = this.props.isEditing
      ? AssetPickerTypes.getItemAdminUrl(itemForUrl)
      : `/training/${this.props.certificationContent.contentId}/overview`;

    return (
      <Title href={href} target="_blank">
        <StyledLinkText>{title}</StyledLinkText>
      </Title>
    );
  };

  getTimeEstimate = () => (
    <div>
      <TimeEstimateIcon src="/images/time_estimate_icon_grey.svg" width="12px" height="12px" />
      {TimeUtils.displayDurationShort(this.props.certificationContent.content.timeEstimateSeconds)}
    </div>
  );
}

const Wrapper = styled.div`
  width: 100%;
  background-color: white;
  line-height: 1.2em;
  padding: 15px;

  display: flex;
  align-items: center;
  box-sizing: border-box;

  border-radius: 3px;
  box-shadow: 0 0px 10px 0 rgba(0, 0, 0, 0.1);
`;

const DragHandleIcon = styled.img`
  margin-right: 15px;
  width: 9px;
  height: 13px;
  cursor: move;
`;

const DeleteIcon = styled.img`
  height: 10px;
  width: 10px;
  margin-left: 10px;
  cursor: pointer;
`;

const Title = styled('a')`
  flex: 1;
  ${common.hideOverflow}
`;

const TimeEstimateIcon = styled.img`
  margin-right: 4px;
`;

const LearningObjectIconMarginAdder = styled.span`
  margin-right: 12px;
`;

const StyledLinkText = styled(Span)`
  color: ${({ theme: propsTheme }) => propsTheme.colors.primary[600]};
`;
